import React from 'react';

export default function WhatMakesUsDifferent() {
  const features = [
    {
      id: 1,
      icon: 'https://cdnbailebelle.pages.dev/what-makeus-dif/female-flamenco-dancer (2).png',
      title: 'Designed for Every Dancer',
      description: 'Crafted to fit and flatter dancers of all shapes, sizes, and skill levels'
    },
    {
      id: 2,
      icon: 'https://cdnbailebelle.pages.dev/what-makeus-dif/high-quality (2).png',
      title: 'Top-Notch Quality',
      description: 'Premium materials and expert craftsmanship in every piece we create'
    },
    {
      id: 3,
      icon: 'https://cdnbailebelle.pages.dev/what-makeus-dif/fast-delivery (1).png',
      title: 'Speedy Delivery',
      description: 'Fast and reliable shipping to get your dance wear when you need it'
    },
    {
      id: 4,
      icon: 'https://cdnbailebelle.pages.dev/what-makeus-dif/shield (2).png',
      title: 'Safe & Secure Shipping',
      description: 'Your orders are protected with secure packaging and tracking'
    }
  ];

  return (
    <section className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: 'serif' }}>
            What Makes Us Different
          </h2>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature) => (
            <div key={feature.id} className="text-center group">
              {/* Icon */}
              <div className="mb-6 flex justify-center">
                <div className="w-20 h-20 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <img
                    src={feature.icon}
                    alt={feature.title}
                    className="w-full h-full object-contain filter brightness-0 invert"
                  />
                </div>
              </div>

              {/* Title */}
              <h3 className="text-xl font-semibold text-white mb-3 transition-colors duration-300"
                  style={{ color: 'white' }}
                  onMouseEnter={(e) => e.target.style.color = '#CF0F63'}
                  onMouseLeave={(e) => e.target.style.color = 'white'}>
                {feature.title}
              </h3>

              {/* Description */}
              <p className="text-gray-400 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
